import type { Organization } from '../types';

export interface OrganizationRecord {
  id: string;
  slug: string;
  name: string;
  short_name: string;
  community_name: string;
  tagline: string | null;
  logo_url: string | null;
  primary_color: string;
  accent_color: string;
}

export function normalizeOrganizationSlug(value: string) {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 48);
}

export function isValidOrganizationSlug(value: string) {
  return value.length >= 3 && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value);
}

export function isValidHexColor(value: string) {
  return /^#[0-9a-f]{6}$/i.test(value);
}

export function mapOrganization(record: OrganizationRecord): Organization {
  return {
    id: record.id,
    slug: record.slug,
    name: record.name,
    shortName: record.short_name,
    communityName: record.community_name,
    tagline: record.tagline ?? '',
    logoUrl: record.logo_url ?? undefined,
    theme: {
      primary: record.primary_color,
      accent: record.accent_color,
      surface: '#f5f7fb',
    },
  };
}
